import { createContext } from 'react';

export const ProfilingContext = createContext({});
